import TableComparative from './TableComparative';
import TableDisponibility from './TableDisponibility';
import TablaIncumplimiento from './tablaIncumplimiento/TablaIncumplimiento';

const Index = () => {
  return ( 
    <>
      {/* <TableComparative /> */}
      <TableDisponibility />
      <TablaIncumplimiento />
    </>
   );
}
 
export default Index;